// extracted by mini-css-extract-plugin
export default {"floating_label_input":"style_floating_label_input__OoiY-","custom_select":"style_custom_select__UBnv6","label":"style_label__4MIUF","labelFloating":"style_labelFloating__jxv1x"};